import React from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./styles.css";
const formatKey = (key) => {
	return key
		.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()) // Remove "_" & capitalize next letter
		.replace(/([A-Z])/g, " $1") // Insert space before uppercase letters
		.replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
		.replace(/_id$/, " ID"); // Change "_id" suffix to " Id"
};
const isValidDate = (value) => {
	// Check if the value is a string that can be reliably parsed as a date
	return (
	  typeof value === "string" &&
	  !isNaN(Date.parse(value)) &&
	  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value) // Strict ISO 8601 format check
	);
  };
  

const VerticalPrimeTable = ({ data, actions = [] }) => {
	if (!data) return null;

	const transformedData = [
		...Object.entries(data)
			.filter(
				([key]) =>
					key !== "deletedAt" && key !== "categoryId" && key !== "blocked"
			)
			.map(([key, value]) => {
				// console.log("key, value", key, value);
				
				if (typeof value === "object" && value !== null && !React.isValidElement(value)) {
					value = value.name || value.username || JSON.stringify(value); 
				} else if (typeof value === "string" && isValidDate(value)) {
					value = new Date(value).toLocaleString('en-GB'); // format date
				}
				return { field: formatKey(key), value };
			}),
		...actions.map(({ label, element }) => ({
			field: label,
			value: element,
		})),
	];

	return (
		<DataTable value={transformedData} className="details-table-logs">
			<Column field="field" header="Field" className="key-column" />
			<Column field="value" header="Value" className="value-column" />
		</DataTable>
	);
};

export default VerticalPrimeTable;
